import {h, Component} from 'preact';

import NavMenus from './NavMenus';
import NavList from './NavList';
import compose from 'ramda/src/compose';
import Icon from '@components/common/Icon';

// todo -> move to global import
const prodFamilyList = [
    'tooth-whitening',
    'triodent',
    'bond-etch',
    'cements',
    'crown-bridge',
    'composites',
    'endodontics',
    'equipment',
    'finish',
    'impressions',
    'orthodontics',
    'prepare',
    'prevent-hygiene',
    'tips-syringes',
    'tissue-management',
    'whats-new'
];

const productIcon = name => ({
    type: 'embed',
    className: `svgi-nav-prodfam--mobile text-2xl -mt-2 -mb-2 mr-2 ${name}`,
    name
});
const uiIcon = name => ({
    type: 'ui',
    className: `text-xl mr-2`,
    name
});
const toIconData = name => {
    if ( name ) {
        return prodFamilyList.includes( name )
            ? productIcon( name )
            : uiIcon( name );
    }

    return null;
};

const createIcon = icon => icon && Icon[icon.type]( icon );
const renderIcon = compose( createIcon, toIconData );

class MobileNav extends Component {
    static list = NavList;
    static menus = NavMenus;
    static renderIcon = renderIcon;
}

export default MobileNav;
